import {kAppStoreLink} from "../../../constants/links";
import {kSystemImages} from "../../../constants/images";

export default function HomeAppStoreButton() {
    // Used in MobileRedirectScreen to display a clickable App Store
    // link

    // BUILD
    return (
        <a href={kAppStoreLink}
           target="_blank"
           rel="noopener noreferrer">
            <div className={"h-[48px] flex items-center justify-center transition-all duration-150 hover:drop-shadow-[0_0_8px_rgba(255,255,255,0.4)]"}>
                <img className={"object-contain h-full"}
                     src={kSystemImages.getItOnAppStore}
                     alt="Disponible sur l'App store" />
            </div>
        </a>
    );
}